import { MapPin, Phone, Navigation } from "lucide-react";
import { HOURS, BUSINESS } from "@/data/site";

const todayIndex = (new Date().getDay() + 6) % 7; // Monday = 0

export const Location = () => {
  return (
    <section
      id="ubicacio"
      data-testid="location-section"
      className="scroll-target py-24 md:py-32 bg-[#FAF5F0]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm uppercase tracking-[0.25em] font-semibold text-[#C8A24A]">
            Ubicació i horari
          </span>
          <h2 className="font-display text-4xl sm:text-5xl font-semibold text-[#8B0000] mt-4">
            On trobar-nos
          </h2>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-6">
          {/* Hours */}
          <div
            data-testid="hours-card"
            className="bg-[#FDFBF7] rounded-2xl border border-[#2C1E16]/10 p-8 sm:p-10 shadow-sm"
          >
            <h3 className="font-display text-2xl font-semibold text-[#2C1E16]">
              Horari d'obertura
            </h3>
            <ul className="mt-6">
              {HOURS.map((h, i) => (
                <li
                  key={h.day}
                  data-testid={`hours-row-${i}`}
                  className={`flex items-start justify-between gap-4 py-3.5 border-b border-[#2C1E16]/10 last:border-0 ${
                    i === todayIndex ? "px-3 -mx-3 rounded-lg bg-[#8B0000]/5" : ""
                  }`}
                >
                  <span
                    className={`font-medium ${
                      i === todayIndex ? "text-[#8B0000]" : "text-[#2C1E16]"
                    }`}
                  >
                    {h.day}
                    {i === todayIndex && (
                      <span className="ml-2 text-[0.65rem] uppercase tracking-wide bg-[#8B0000] text-[#FDFBF7] px-2 py-0.5 rounded-full align-middle">
                        Avui
                      </span>
                    )}
                  </span>
                  <span className="text-right text-[#5C4A3D]">
                    {h.closed ? (
                      <span className="text-[#8B0000] font-medium">Tancat</span>
                    ) : (
                      h.slots.map((s) => <span key={s} className="block">{s}</span>)
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Map + address */}
          <div className="flex flex-col gap-6">
            <div
              data-testid="map-card"
              className="rounded-2xl overflow-hidden border border-[#2C1E16]/10 shadow-sm flex-1 min-h-[260px]"
            >
              <iframe
                title="Mapa Pastisseria Solís"
                src={BUSINESS.mapEmbed}
                className="w-full h-full min-h-[260px]"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <div className="bg-[#FDFBF7] rounded-2xl border border-[#2C1E16]/10 p-8 shadow-sm">
              <div className="flex items-start gap-3">
                <MapPin className="text-[#8B0000] shrink-0 mt-1" size={20} />
                <p className="text-[#2C1E16]">{BUSINESS.address}</p>
              </div>
              <div className="flex items-center gap-3 mt-4">
                <Phone className="text-[#8B0000] shrink-0" size={20} />
                <a
                  data-testid="location-phone"
                  href={`tel:${BUSINESS.phoneTel}`}
                  className="text-[#2C1E16] hover:text-[#8B0000] transition-colors"
                >
                  {BUSINESS.phoneDisplay}
                </a>
              </div>
              <a
                data-testid="location-directions-btn"
                href={BUSINESS.mapsLink}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#8B0000] text-[#FDFBF7] px-6 py-3 font-semibold hover:-translate-y-0.5 hover:shadow-lg transition-all"
              >
                <Navigation size={17} /> Com arribar
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
